import { render, staticRenderFns } from "./ScwlContractScrollBoard.vue?vue&type=template&id=55ad5b21"
import script from "./ScwlContractScrollBoard.vue?vue&type=script&lang=js"
export * from "./ScwlContractScrollBoard.vue?vue&type=script&lang=js"
import style0 from "./ScwlContractScrollBoard.vue?vue&type=style&index=0&id=55ad5b21&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports